import React from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableCell,
} from "@mui/material";
import ReceiptDetails from "./ReceiptDetails";
import { EmptyRow } from "../../invoiceGeneration/InvoiceFooter";
import {
  HeadItemCell,
  HeadHSNCell,
  HeadPreTaxCell,
  ServiceCell,
  TaxLabelCell,
  TaxValueCell,
  AmountInWordsCell,
  OutstandingLeftCell,
  OutstandingRightCell,
  LabelSpan,
  DivText,
  TotalText,
} from "./ReceiptSummaryStyles";

type ReceiptDetailsProps = {
  previewData: any;
};

const ReceiptSummary: React.FC<ReceiptDetailsProps> = ({ previewData }) => {
  const preTaxTotal =
    previewData?.creditAmount ?? previewData?.preTaxTotal ?? 0;
  const grandTotal = preTaxTotal;
  const hsnSac = previewData?.hsnSac || "N/A";
  const outstandingValue =
    previewData?.outstandingAmount ?? previewData?.outstandingValue ?? 0;
  const amountInWords = previewData?.amountInWords || "";
  const sellerName =
    previewData?.org?.name ||
    previewData?.org?.organizationName ||
    previewData?.sellerName ||
    "";

  // Display all selected invoice numbers
  const invoiceNos = previewData?.invoiceNos || [];
  const creditNoteTowardsInvoice =
    Array.isArray(invoiceNos) && invoiceNos.length > 0
      ? invoiceNos.join(", ")
      : previewData?.creditNoteTowardsInvoice || "";

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow
            sx={{
              borderBottom: "3px solid black",
              borderTop: "3px solid black",
            }}
          >
            <HeadItemCell>Item</HeadItemCell>
            <HeadHSNCell>HSN/SAC</HeadHSNCell>
            <HeadPreTaxCell>Pre Tax Amount (Rs.)</HeadPreTaxCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <ServiceCell>
              1. Credit Note Towards Invoice- {creditNoteTowardsInvoice}
            </ServiceCell>
            <ServiceCell>{hsnSac}</ServiceCell>
            <ServiceCell sx={{ borderRight: "0" }}>{preTaxTotal}</ServiceCell>
          </TableRow>

          <TableRow
            sx={{
              borderTop: "3px solid black",
              borderBottom: "3px solid black",
            }}
          >
            <TableCell sx={{ verticalAlign: "top", paddingLeft: "5px" }}>
              <ReceiptDetails
                previewData={previewData}
                showAccountDetails={true}
              />
            </TableCell>
            <TaxLabelCell>
              <DivText>Pre-Tax Total (Rs.):</DivText>
              <TotalText>Grand Total:</TotalText>
            </TaxLabelCell>
            <TaxValueCell>
              <DivText>{preTaxTotal.toLocaleString()}</DivText>
              <TotalText>{grandTotal.toLocaleString()}</TotalText>
            </TaxValueCell>
          </TableRow>

          <TableRow sx={{ borderBottom: "3px solid black" }}>
            <AmountInWordsCell colSpan={3}>
              <LabelSpan>Amount in Words:</LabelSpan> {amountInWords}
            </AmountInWordsCell>
          </TableRow>

          <TableRow sx={{ borderBottom: "3px solid black" }}>
            <OutstandingLeftCell>
              <LabelSpan>Outstanding Amount:</LabelSpan>{" "}
              {outstandingValue.toLocaleString()}
            </OutstandingLeftCell>
            <OutstandingRightCell colSpan={2}>
              <LabelSpan>For {sellerName || "—"}</LabelSpan>
            </OutstandingRightCell>
          </TableRow>

          <EmptyRow />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReceiptSummary;
